import jsPDF from 'jspdf';
import DateFormatResolver from 'resolvers/date-format.resolver';
import moment from 'moment';
import { reportsNames } from './report.service';

const createChartPage = (pdfInstance, chartParams) => {
	const {
		element,
		title,
		dateFrom,
		dateTo,
		granularity,
		contactCenterName,
		legend,
		reportName,
	} = chartParams;

	let dateFormat;
	let from;
	let to;
	let granularityLabel;

	if (granularity === 'hour') {
		dateFormat = 'DD MMM `YY hA';
		from = DateFormatResolver.resolve(moment().subtract(1, 'day').toDate(), dateFormat);
		to = DateFormatResolver.resolve(new Date(), dateFormat);
		granularityLabel = 'Hourly';
	} else {
		dateFormat = 'DD MMM `YY';
		from = DateFormatResolver.resolve(dateFrom, dateFormat);
		to = DateFormatResolver.resolve(dateTo, dateFormat);
		granularityLabel = 'Daily';
	}

	const col1 = 10;
	const col2 = 45;
	const col3 = 180;
	const col4 = 270;
	const row1 = 45;
	const row2 = 70;

	pdfInstance.setTextColor('#000');
	pdfInstance.setFontSize(22);
	pdfInstance.text(title, 10, 20);
	pdfInstance.setFontSize(16);

	const addDateRange = () => {
		pdfInstance.setTextColor('#000');
		pdfInstance.text('From:', col1, row1);
		pdfInstance.text('To:', col1, row2);
		pdfInstance.text('Granularity:', col3, row1);
		pdfInstance.setTextColor('#aaa');
		pdfInstance.text(from, col2, row1);
		pdfInstance.text(to, col2, row2);
		pdfInstance.text(granularityLabel, col4, row1);
	};

	const addContactCenterInfo = () => {
		pdfInstance.setTextColor('#000');
		pdfInstance.text('Contact Center:', col3, row2);
		pdfInstance.setTextColor('#aaa');
		pdfInstance.text(contactCenterName, col4, row2);
	};

	switch (reportName) {
		case reportsNames.registrations:
			addDateRange();
			break;
		case reportsNames.goodCallsCount:
		case reportsNames.goodCallsAnsweredCount:
		case reportsNames.goodCallsAnswerSuccessRate:
		case reportsNames.spoofedCallsCountWithCustomers:
		case reportsNames.spoofedCallsNotAnsweredSuccessRate:
		case reportsNames.customersUnderAttackCount:
		case reportsNames.ratingsDistribution:
		default:
			addDateRange();
			addContactCenterInfo();
			break;
	}

	const canvas = element.querySelector('canvas');
	const imageY = 100;
	const imageX = 10;
	if (canvas) {
		const img = canvas.toDataURL('image/png');
		let chartWidth = 600;
		const maxChartHeight = 430 - imageY;
		const aspectRatio = canvas.clientWidth / canvas.clientHeight;

		let height = chartWidth / aspectRatio;

		if (height > maxChartHeight) {
			height = maxChartHeight;
			chartWidth = aspectRatio * height;
		}

		pdfInstance.addImage(
			img,
			'png',
			imageX,
			imageY,
			chartWidth,
			height
		);
		if (legend) {
			let x = 30;
			let y = imageY + height + 20;
			legend.forEach(({ color, text }, index) => {
				pdfInstance.setFillColor(color);
				pdfInstance.circle(x, y + index * 15 - 5, 5, 'F');
				pdfInstance.text(text, x + 10, y + index * 15);
			})
		}
	} else {
		pdfInstance.setTextColor('#aaa');
		pdfInstance.text('There is no data for selected period', 220, 250);
	}
};

const downloadChartsPdf = (charts = []) => {
	const pdf = new jsPDF('l', 'px', 'a4');

	charts.forEach((chart, index) => {
		if (index !== 0) {
			pdf.addPage();
		}
		createChartPage(pdf, chart);
	});
	const fileCreationTime = moment().format('YYYY-MM-DD_HH-mm-ss');
	const fileName = charts.length === 1 && charts[0].title
		? charts[0].title
		: 'Dashboards & Analytics';
	pdf.save(`${fileName}_${fileCreationTime}.pdf`);
};

const downloadFile = (data, extension, name = 'file') => {
	const blob = new Blob([data]);
	const link = document.createElement('a');

	link.href = window.URL.createObjectURL(blob);
	link.download = `${name}.${extension}`;
	link.click();
};

export { downloadFile, downloadChartsPdf };
